import ReportPage from "../../components/ReportPage";
import { downloadDistributionByBannerByItem } from "../../API";

const schema = {
  title: "Distribution by Banner by Item",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: true,
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        const statusSearch = status === "ALL" ? "" : `,status:${status}`;
        return `?search=manufacturer:${manufacturer.id}${statusSearch}&size=1000`;
      },
    },
  ],
  downloadFn: downloadDistributionByBannerByItem,
};

export default function DistributionByBannerByItemReport() {
  return <ReportPage schema={schema} />;
}
